import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { env } from "@env/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { StatoApplicazioneDTO } from "../dto/stato-applicazioneDTO";
import { MapperStatoApplicazione } from "../mapper/mapper-stato-applicazione";
import { StatoApplicazioneVO } from "../vo/stato-applicazioneVO";

@Injectable({
  providedIn: "root",
})
export class StatoApplicazioneService {
  constructor(
    private http: HttpClient,
    private mapperStatoApplicazione: MapperStatoApplicazione
  ) { }

  getStatoApplicazione(): Observable<StatoApplicazioneVO> {
    const url =
      env.DOCUMENTALE_API_URL_BASE +
      env.STATO_APPLICAZIONE_URL;
    console.log("[StatoApplicazioneService.getStatoApplicazione] url:", url);
    return this.http.get<StatoApplicazioneDTO>(url).pipe(
      catchError((err) => {
        // this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      }),
      map((result: StatoApplicazioneDTO) =>
        this.mapperStatoApplicazione.convertDtoToVo(result)
      )
    );
  }
}

function observableThrowError(err: any): any {
  throw new Error("Function not implemented.");
}
